import { render, staticRenderFns } from "./NaturalResourcesTable.vue?vue&type=template&id=573f1abc&scoped=true&"
import script from "./NaturalResourcesTable.vue?vue&type=script&lang=js&"
export * from "./NaturalResourcesTable.vue?vue&type=script&lang=js&"
import style0 from "./NaturalResourcesTable.vue?vue&type=style&index=0&id=573f1abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f1abc",
  null
  
)

export default component.exports